const MODULE_NAME = 'capitalize';
export default angular.module(MODULE_NAME, [])
	.filter('capitalize', function () {
		return function (input) {
			return angular.isString(input) && input.length > 0 ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : input;
		};
	}).name;



// WEBPACK FOOTER //
// ./source/common/capitalize/capitalize.js